export default "__VITE_ASSET__BFTsRtxX__"